/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

var sections = window.theme.sections;
var slideshowAutoExtension = {
  init: function() {
    this.on('slideshow_desktop_init_done', this._autoplaySlideshow.bind(this));
  },
  _autoplaySlideshow: setInterval(function() {
    var $slide = $('.slideshow__slide--active')
                   .removeClass('slideshow__slide--active');

    var $button = $('.slideshow__button--active')
                   .removeClass('slideshow__button--active');

    var $slides = $('.slideshow__slide');

    var currentIndex = ($slides.index($slide) + 1) % $slides.length;

    $slides
      .eq(currentIndex)
      .addClass('slideshow__slide--active');

    var $buttons = $('.slideshow__button')
      .eq(currentIndex)
      .addClass('slideshow__button--active');

  }, 15000)

};

sections.extend('slideshow', slideshowAutoExtension);

var texts = ["A SPACE <br>TO EDUCATE", "A SPACE <br>TO LIVE", "A SPACE <br>TO EXPRESS", "A SPACE <br>TO SUSTAIN", "A SPACE <br>FOR CHANGE"
];
var count = -1;


function changeText() {
    $("#text-spin").fadeOut(0, function() {
        count < 5 ? count++ : count = 0;
        $("#text-spin").html(texts[count]);
        $("#text-spin").fadeIn(0)
    });
}

setInterval(changeText, 500);



  /*filter*/

  var filterActive;

  function filterCategory(category) {
    if (filterActive != category) {
      // reset results list
      $('.filter-cat-results .f-cat').removeClass('active'); // elements to be filtered
      $('.filter-cat-results .f-cat').filter('[data-cat="' + category + '"]').addClass('active'); // reset active filter
      filterActive = category;
      $('.filtering button').removeClass('active');
    }
  }

  if(window.location.hash) {
    var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
    $('.filtering button').removeClass('active');
    $('.filter-cat-results .f-cat').removeClass('active'); // elements to be filtered
    var hash = "cat-" + window.location.hash.substring(1);
    var hash_clear = "" + window.location.hash.substring(1);
    $('.filter-cat-results .f-cat').filter('[data-cat="' + hash + '"]').addClass('active');
    $('.f-button').removeClass('active');
    $('.data-' + hash_clear).addClass('active');
  } else {
    $('.f-cat').addClass('active');
  }

  $('.f-button').click(function () {
    $(".filter-system, .banner-projects, .filter, .close").removeClass("active");
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $('.filter-cat-results .f-cat').addClass('active'); // elements to be filtered
      filterActive = 'cat-all';
      $('.f-button').removeClass('active');
    } else {
      // $('.all-marquee').removeClass('active');
      $('.f-button').removeClass('active');
      $('.f-cat').removeClass('active');
  
        var self = this;
        setTimeout(function () {
          filterCategory($(self).addClass('active').attr('data-cat'));
          var hash = "cat-" + window.location.hash.substring(1);
          $('.' + hash).addClass('active');
        }, 1);
        $(this).addClass('active');
    }
  });

  const players = Plyr.setup('.player', {
    //  controls: ['play-large', 'play', 'mute']
    controls: ['play-large', 'play', 'mute'],
    youtube: {
      showinfo: 0, 
      modestbranding: 1,
      preload: false,
      rel: 0
    },
    autoplay: true,
    muted: true,
    preload: false,
    noCookie: false, 
    rel: 0, 
    showinfo: 0, 
    modestbranding: 1 
    });


  const player = new Plyr('#player', {
  //  controls: ['play-large', 'play', 'mute']
  controls: ['play-large', 'play', 'mute'],
  youtube: {
    showinfo: 0, 
    modestbranding: 1,
    preload: false,
    rel: 0
  },
  autoplay: true,
  muted: true,
  preload: false,
  noCookie: false, 
  rel: 0, 
  showinfo: 0, 
  modestbranding: 1 
  });

  const players_article = Array.from(document.querySelectorAll('.player-article')).map((p) => new Plyr(p));


     const player_7 = new Plyr('#player-article-6', {
      controls: ['play-large', 'play', 'mute'],
      noCookie: false, 
      rel: 0, 
      showinfo: 0, 
      modestbranding: 1,
      youtube: {
       showinfo: 0, 
       modestbranding: 1,
       preload: false,
       rel: 0
     }
     });
  

  player.on('ready', () => {
    player.play();
    $('.video-section').addClass('active');
  })


  var $status = $('.pagingInfo');
var $slickElement = $('.legacy-slider');

$slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    $status.text(i + '/' + slick.slideCount);
});


  $( document ).ready(function() {
    $('.legacy-slider').slick({
      infinite: true,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
});

	